import { Header } from '@/components/Header';
import { Footer } from '@/components/Footer';
import { ServiceLeadForm } from '@/components/ServiceLeadForm';
import { Button } from '@/components/ui/button';
import { Badge } from '@/components/ui/badge';
import { ChefHat, ExternalLink, ArrowRight } from 'lucide-react';

export const MontageCuisinePage = () => {
  const questions = [
    { id: 'type_cuisine', label: 'Type de cuisine ?', type: 'select', options: ['Cuisine complète', 'Éléments hauts', 'Éléments bas', 'Plan de travail', 'Électroménager'] },
    { id: 'marque', label: 'Marque / Fournisseur ?', type: 'select', options: ['IKEA', 'Schmidt', 'Cuisines Références', 'Sur mesure', 'Autre'] },
    { id: 'etat', label: 'État actuel ?', type: 'select', options: ['Cuisine neuve à installer', 'Remplacement partiel', 'Ajout d\'éléments'] },
    { id: 'delai', label: 'Délai souhaité ?', type: 'select', options: ['Urgent (sous 1 semaine)', '1-2 semaines', 'Flexible'] }
  ];

  return (
    <div className="min-h-screen bg-background">
      <Header />
      
      <section className="py-20" style={{ backgroundColor: 'var(--sage)', color: 'white' }}>
        <div className="mx-auto w-full max-w-[var(--container)] px-4 sm:px-6 lg:px-8">
          <div className="flex items-center gap-3 mb-6">
            <ChefHat className="h-10 w-10" />
            <Badge className="bg-white/20 text-white border-white/30">Homely Montage</Badge>
          </div>
          <h1 className="text-4xl sm:text-5xl font-bold mb-6" style={{ fontFamily: 'var(--font-heading)' }}>
            Agencement et montage de cuisine
          </h1>
          <p className="text-lg text-white/90 mb-8 max-w-2xl">
            Installation complète de votre cuisine équipée : meubles, plan de travail, raccordements. Un travail soigné pour une cuisine fonctionnelle et esthétique.
          </p>
          <div className="flex flex-col sm:flex-row gap-4">
            <Button 
              size="lg" 
              className="btn-premium h-14 px-10 rounded-full"
              onClick={() => document.getElementById('form').scrollIntoView({ behavior: 'smooth' })}
            >
              Demander un devis
              <ArrowRight className="ml-2 h-5 w-5" />
            </Button>
            <Button 
              size="lg" 
              variant="outline"
              className="h-14 px-8 rounded-full bg-white/10 border-white/30 text-white hover:bg-white hover:text-[var(--anthracite)] gap-2"
              onClick={() => window.open('https://www.homely-montage.ch', '_blank')}
            >
              <ExternalLink className="h-4 w-4" />
              homely-montage.ch
            </Button>
          </div>
        </div>
      </section>

      <section className="py-16 gradient-premium">
        <div className="mx-auto w-full max-w-[var(--container)] px-4 sm:px-6 lg:px-8">
          <div className="text-center mb-10">
            <h2 className="text-3xl font-bold mb-4" style={{ fontFamily: 'var(--font-heading)' }}>Nos prestations cuisine</h2>
            <div className="section-divider"></div>
          </div>
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4 max-w-3xl mx-auto">
            {['Montage meubles cuisine', 'Pose plan de travail', 'Découpe évier', 'Installation électroménager', 'Raccordement eau', 'Finitions'].map((s, i) => (
              <div key={i} className="card-premium p-4 text-center">
                <h3 className="font-semibold">{s}</h3>
              </div>
            ))}
          </div>
        </div>
      </section>

      <section className="py-16" style={{ backgroundColor: 'var(--anthracite)' }} id="form">
        <div className="mx-auto w-full max-w-2xl px-4 sm:px-6 lg:px-8">
          <div className="bg-white rounded-2xl p-8 shadow-2xl">
            <ServiceLeadForm service="montage" pole="cuisine" questions={questions} />
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
};
